import { z } from "zod/v4-mini";

import { DeviceType, deviceTypeSchema } from "@/models/MedicalDeviceModel.ts";
import { Schema, cz } from "@/utils/zodUtils.ts";

/***********************
 *   Glycemia types    *
 ***********************/

export const glycemiaMeasureTypeSchema = z.literal(["interstitial", "capillary"]);
export type GlycemiaMeasureType = z.infer<typeof glycemiaMeasureTypeSchema>;
export const glycemiaPeriodSchema = z.literal(["breakfast", "lunch", "dinner", "before_bed"]);
export type GlycemiaPeriod = z.infer<typeof glycemiaPeriodSchema>;
export const glycemiaPeriodTimingSchema = z.literal(["before", "after"]);
export type GlycemiaPeriodTiming = z.infer<typeof glycemiaPeriodTimingSchema>;

export type Glycemia = {
  id: string;
  patientId: string;
  date: string;
  deviceId?: string;
  deviceType?: DeviceType;

  type: GlycemiaMeasureType;
  value: number;
  period?: GlycemiaPeriod;
  periodTiming?: GlycemiaPeriodTiming;
  outOfRange?: "high" | "low";
};

export type ReaderGlycemia = Omit<Glycemia, "type"> & {
  type: "capillary";
};

export type SensorGlycemia = Omit<Glycemia, "type"> & {
  type: "interstitial";
};

export type SplitGlycemiaData = {
  reader: ReaderGlycemia[];
  sensor: SensorGlycemia[];
};

export const glycemiaSchema: Schema<Glycemia> = cz.camelCaseObject({
  id: cz.id(),
  patient_id: z.string(),
  date: cz.datetime(),
  device_id: cz.optional(cz.id()),
  device_kind: cz.optional(deviceTypeSchema),
  type: glycemiaMeasureTypeSchema,
  period: glycemiaPeriodSchema,
  period_timing: glycemiaPeriodTimingSchema,
  out_of_range: cz.optional(z.literal(["high", "low"])),
  value: z.number(),
});
